"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function iDef(o) { return typeof o !== "undefined"; }
exports.iDef = iDef;
function nDef(o) { return typeof o === "undefined"; }
exports.nDef = nDef;
function cAsgn(to, from) {
    if (iDef(from)) {
        to = from;
    }
}
exports.cAsgn = cAsgn;
//# sourceMappingURL=TypeUtils.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/decorator-form/dist/util/TypeUtils.js
// module id = 791
// module chunks = 0